"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral")),
    _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    query GetCampaigns(\n      $organisationId: String!, \n      $offset: Int,\n      $limit: Int,\n      $filter: CampaignFilter     \n    ) {\n      getCampaigns(\n        organisationId: $organisationId, offset: $offset, limit: $limit, filter: $filter\n        ) {\n        count\n        campaigns {\n          inspirationCampaignId\n          name\n          description\n          tags\n          coverImageKey\n          }\n        }\n    }\n"]);
  return _templateObject = function _templateObject() {
    return data;
  }, data;
}

var getCampaignsQuery = (0, _graphqlTag["default"])(_templateObject()),
    getCampaigns = {
  query: getCampaignsQuery,
  module: "inspirations",
  ignoreCache: !0,
  buildVariables: function buildVariables(variables) {
    return variables;
  }
},
    _default = getCampaigns;
exports["default"] = _default;